// extracted by mini-css-extract-plugin
export default {"price":"f0-z","onSale":"g0-z","msrpLabelPrice":"h0-z","originalPrice":"i0-z","msrpLabel":"j0-z","percentOff":"k0-z"};